import React from 'react';

import { token } from '@atlaskit/tokens';
import { css } from '@compiled/react';

const iconSizeStyles = css({
	height: '16px',
	width: '16px',
});

export const TrophyIcon = () => {
	return (
		<svg css={iconSizeStyles} viewBox="0 0 24 24">
			<path
				d="M 3.4156 3.333 H 7.4156 C 8.1516 3.333 8.667 3.2637 8.667 3.9997 V 2.6663 C 8.667 1.9303 8.1516 1.333 7.4156 1.333 H 2.0823 C 0.749 1.333 -0.3064 2.7497 0.0823 4.6663 C 0.0823 4.6663 1.2763 10.9163 1.3603 11.305 C 1.5823 12.333 2.7763 13.333 4.0543 13.333 H 8.693 C 9.4296 13.333 8.667 12.069 8.667 11.333 V 9.9997 C 8.667 10.7357 8.1516 11.333 7.4156 11.333 H 4.749 C 4.013 11.333 3.527 10.6383 3.4156 9.9997 C 3.3043 9.361 2.3596 5.111 2.3596 5.111 C 2.1376 3.833 2.679 3.333 3.4156 3.333 Z M 20.6237 3.333 H 16.6236 C 15.8877 3.333 14.667 3.2637 14.667 3.9997 V 2.6663 C 14.667 1.9303 15.8877 1.333 16.6236 1.333 H 21.957 C 23.2904 1.333 24.3463 2.7497 23.9569 4.6663 C 23.9569 4.6663 22.8682 10.9457 22.7763 11.333 C 22.5404 12.333 21.4149 13.333 20.1096 13.333 H 15.3456 C 14.6096 13.333 14.667 12.069 14.667 11.333 V 9.9997 C 14.667 10.7357 15.8877 11.333 16.6236 11.333 H 19.2903 C 20.0264 11.333 20.513 10.6383 20.6237 9.9997 C 20.7343 9.361 21.6796 5.111 21.6796 5.111 C 21.9009 3.833 21.3603 3.333 20.6237 3.333 Z M 13.8883 14.6663 C 13.8883 10.0277 12.0823 14.6663 12.0823 14.6663 C 12.0823 14.6663 10.0823 10.0277 10.0823 14.6663 C 10.0823 19.305 7.8883 21.333 7.8883 21.333 H 16.083 C 16.0823 21.333 13.8883 19.305 13.8883 14.6663 Z"
				fill={token('color.background.accent.orange.subtle')}
			/>
			<path
				d="M 19.415 4.3844 C 19.415 8.9011 14.9016 16.5125 12.0816 16.5125 C 9.261 16.5125 4.7483 8.9011 4.7483 4.3844 C 4.7483 0.9211 5.415 0.1717 6.7483 0.1717 C 7.6643 0.1717 10.765 0.1537 12.0816 0.1537 L 16.7482 0.1531 C 18.693 0.1524 19.415 0.6091 19.415 4.3844 Z"
				fill={token('color.background.warning.bold')}
			/>
			<path
				d="M 18 22.0002 C 18 22.7363 18.1514 23.3335 17.4153 23.3335 H 6.7487 C 6.012 23.3335 6 22.7363 6 22.0002 V 21.3336 C 6 20.5975 6.776 20.0003 7.4707 20.0003 H 16.7487 C 17.4433 20.0003 18 20.5975 18 21.3336 V 22.0002 Z"
				fill={token('color.background.accent.red.subtle')}
			/>
			<path
				d="M 19.3336 23.0831 C 19.3336 23.5897 19.4436 23.9997 18.4991 23.9997 H 5.6657 C 4.8043 23.9997 4.667 23.5897 4.667 23.0831 V 22.9164 C 4.667 22.4097 5.159 21.9997 5.6657 21.9997 H 18.4991 C 19.005 21.9997 19.3336 22.4097 19.3336 22.9164 V 23.0831 Z"
				fill={token('color.background.accent.red.subtle')}
			/>
		</svg>
	);
};
